interface User {
  id: string;
  name: string;
  email: string;
}

interface Company {
  id: number;
  name: string;
  email: string;
}

const setCompanyGroup = (company: Company): void => {
  if (!company || !company.id || !window.posthog) {
    return;
  }

  window.posthog.group('company', company.id, company);
};

export const setPosthogIdentify = (
  user: User,
  company: Company,
): void => {
  if (!user || !user.email || !window.posthog) {
    return;
  }

  window.posthog.identify(user.email, user);
  setCompanyGroup(company);
};

export const resetPosthogUser = (): void => {
  if (window.posthog) {
    window.posthog.reset();
  }
};
